import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import IntlMessages from "../../../../util/IntlMessages";
import { Button, Input, Message, Switch } from "../../../BP2Components";
import { setWidgetInSheetParams } from "../../../../appRedux/actions/Boards";
import "../GlobalSettings/GlobalSettings.less";
import "../../InfiniteListWidget/InfiniteList.less";

interface ListBuilderSettingsProps {
   value: any;
}

const ListBuilderSettings: React.FC<ListBuilderSettingsProps> = ({ value }) => {
   return (
      <div
         className="widget-settings"
         style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
         }}
      >
         <span style={{ fontSize: "2rem" }}>Nothing to do here</span>
         <span style={{ fontSize: "15rem" }}>(˚Δ˚)</span>
      </div>
   );
};

export default ListBuilderSettings;
